import * as googleMap from 'services/googleMaps';

export const getDetailedZipInfo = async (zip: string, countryCode: string) => {
  const rawGoogleData = await googleMap.getAddressInfo(zip, countryCode);

  return {
    address: formatAddress(googleMap.getAddress(rawGoogleData, zip)),
    coordinates: googleMap.getCoordinates(rawGoogleData)
  };
};

const formatAddress = (address: string) => {
  const addressToArray = address.split(' ');
  const addressWithoutCountry = addressToArray.slice(0, -1);
  return addressToArray.length && addressWithoutCountry.length
    ? addressWithoutCountry.join(' ').replace(/,*$/, '')
    : address;
};
